var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.9485 31.6337H12.0484C11.3484 31.6337 10.7151 31.1837 10.4818 30.5337L3.54845 11.1171C2.99845 9.56706 4.76511 8.25039 6.08178 9.20039L12.7484 13.9671C13.6318 14.6004 14.8984 14.2171 15.2818 13.2004L18.4318 4.80039C18.9651 3.35039 21.0151 3.35039 21.5484 4.80039L24.6984 13.2004C25.0818 14.2337 26.3318 14.6004 27.2318 13.9671L33.8984 9.20039C35.2318 8.25039 36.9818 9.58372 36.4318 11.1171L29.4984 30.5337C29.2818 31.1837 28.6484 31.6337 27.9485 31.6337Z",
    fill: "#4D4DFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3346 36.666H11.668C10.9846 36.666 10.418 36.0993 10.418 35.416C10.418 34.7327 10.9846 34.166 11.668 34.166H28.3346C29.018 34.166 29.5846 34.7327 29.5846 35.416C29.5846 36.0993 29.018 36.666 28.3346 36.666Z",
    fill: "#4D4DFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1654 24.584H15.832C15.1487 24.584 14.582 24.0173 14.582 23.334C14.582 22.6507 15.1487 22.084 15.832 22.084H24.1654C24.8487 22.084 25.4154 22.6507 25.4154 23.334C25.4154 24.0173 24.8487 24.584 24.1654 24.584Z",
    fill: "#4D4DFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitImg2);
export default __webpack_public_path__ + "static/media/benefit-img2.9ea5782b702dc28e5813eaa557e385c4.svg";
export { ForwardRef as ReactComponent };